<mat-accordion class="expansionPanel" displayMode="flat">
  <div class="expansionPanel__outerContainer">
    <mat-expansion-panel #panelStep1 [expanded]="step === 1 && selectedExercises.length != 0" [disabled]="selectedExercises.length == 0" (opened)="setStep(1)" hideToggle="true">
      <mat-expansion-panel-header [@listChange]="selectedExercises.length">
        <mat-panel-title>
          <span [innerHTML]="'EXERCISES.EDITOR.selectedExercisesText' | translate:{some: selectedExercises.length, all:3}"></span>

          <span class="title-button"><button [disabled]="panelStep1.disabled || step == 2" mat-button color="primary" (click)="forceSetStep($event,2)">{{'EXERCISES.EDITOR.nextStepBtn' | translate}}</button></span>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="expansionPanel__1stContainer">
        <app-box *ngFor="let ex of selectedExercises" [@flyInOut]
             [id]="ex._id"
             [boxType]="'ex'"
             [type]="'remove'"
             [preview]="ex.previewUrl"
             [title]="ex.title[translate.currentLang]"
             (onSelect)="remove(ex)">
        </app-box>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel [expanded]="step === 2 && selectedExercises.length != 0" [disabled]="selectedExercises.length == 0" (opened)="setStep(2)" (closed)="setStep(0)" hideToggle="true">
      <div class="expansionPanel__2ndContainer">
        <app-input>
          <mat-expansion-panel-header >
            <mat-panel-title>
              {{'EXERCISES.EDITOR.nameStepHeader' |translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <input type="text" [(ngModel)]="title">
        </app-input>
      </div>
      <mat-action-row>
        <button mat-raised-button button color="primary" (click)="imDone()">{{'EXERCISES.EDITOR.doneEditingBtn' |translate}}</button>
      </mat-action-row>
    </mat-expansion-panel>

  </div>
</mat-accordion>



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/expansion-panel/expansion-panel.component.html